import {
  Box,
  Button,
  CircularProgress,
  IconButton,
  Stack,
  Tab,
  Tabs,
  Typography,
} from "@mui/material";
import Iconify from "../iconify/Iconify";
import CoinTransactionsTable from "../transactions-table/CoinTransactionsTable";
import PurchasesTable from "../purchases-table/PurchasesTable";
import RewardsTable from "../reward-table/RewardTable";
import UserDivisionLeaguesTable from "../stage-admin/UserDivisionLeaguesTable";
import InboxTable from "../inbox-table/InboxTable";
import VersusContractsTable from "../profile/VersusContractsTable";
import VersusUserGamesTable from "../versus/VersusUserGamesTable";
import TicketTransactionsTable from "../transactions-table/TicketTransactionsTable";
import UserLevelTable from "../user-level-table/UserLevelTable";

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 1, paddingTop: 3 }}>{children}</Box>}
    </div>
  );
}

export default function ProfileTabsSection({
  value,
  handleChangeTabs,
  handleOpenMenu,
  userId,
  transactions,
  purchases,
  referralRewards,
  xpRewards,
  divisionLeagues,
  messages,
  userLevel,
  userLevelStats,
  versusContracts,
  ticketTransactions,
  versusTabValue,
  handleChangeVersusTabs,
  setOpenAddCoinsDialog,
  setOpenAllAccessPassDialog,
  setOpenReferralCodeDialog,
  setOpenAddXpDialog,
  setSelectedDivisionLeagueId,
  setOpenAddVersusPackDialog,
  setOpenAddTicketsDialog,
}) {
  return (
    <Box sx={{ width: "100%" }}>
      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
        <Tabs
          value={value}
          onChange={handleChangeTabs}
          aria-label="basic tabs example"
        >
          <Tab label="Coins" {...a11yProps(0)} />
          <Tab label="IAP" {...a11yProps(1)} />
          <Tab label="Refer a Friend" {...a11yProps(2)} />
          <Tab label="XP Rewards" {...a11yProps(3)} />
          <Tab label="Divisions" {...a11yProps(4)} />
          <Tab label="Inbox" {...a11yProps(5)} />
          <Tab label="Versus" {...a11yProps(6)} />
          <Tab label="Tickets" {...a11yProps(7)} />
          <Tab label="User Level" {...a11yProps(8)} />
          <div>
            <IconButton
              size="large"
              color="inherit"
              onClick={handleOpenMenu}
              id={userId}
            >
              <Iconify icon={"eva:more-vertical-fill"} />
            </IconButton>
          </div>
        </Tabs>
      </Box>
      <TabPanel value={value} index={0}>
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          mb={5}
        >
          <Typography variant="h4" gutterBottom></Typography>
          <Button
            variant="contained"
            startIcon={<Iconify icon="eva:plus-outline" />}
            onClick={() => setOpenAddCoinsDialog(true)}
          >
            Add Coins
          </Button>
        </Stack>
        {transactions === null ? (
          <Box
            sx={{ display: "flex", justifyContent: "center" }}
            style={{ padding: 20 }}
          >
            <CircularProgress />
          </Box>
        ) : (
          <CoinTransactionsTable transactions={transactions} />
        )}
      </TabPanel>
      <TabPanel value={value} index={1}>
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          mb={5}
        >
          <Typography variant="h4" gutterBottom></Typography>
          <Button
            variant="contained"
            startIcon={<Iconify icon="eva:plus-outline" />}
            onClick={() => setOpenAllAccessPassDialog(true)}
          >
            Add All Access Pass
          </Button>
        </Stack>
        <PurchasesTable purchases={purchases} />
      </TabPanel>
      <TabPanel value={value} index={2}>
        <Stack direction="row" alignItems="center" justifyContent="end" mb={5}>
          <Button
            sx={{ ml: 2 }}
            variant="contained"
            startIcon={<Iconify icon="eva:plus-outline" />}
            onClick={() => setOpenReferralCodeDialog(true)}
          >
            Referral Code
          </Button>
        </Stack>
        {referralRewards !== null && <RewardsTable rewards={referralRewards} />}
      </TabPanel>
      <TabPanel value={value} index={3}>
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          mb={5}
        >
          <Typography variant="h4" gutterBottom></Typography>
          <Button
            variant="contained"
            startIcon={<Iconify icon="eva:plus-outline" />}
            onClick={() => setOpenAddXpDialog(true)}
          >
            Add XP Rewards
          </Button>
        </Stack>
        {xpRewards !== null && <RewardsTable rewards={xpRewards} />}
      </TabPanel>
      <TabPanel value={value} index={4}>
        {divisionLeagues !== null && (
          <UserDivisionLeaguesTable
            rows={divisionLeagues}
            onLeaderboardClick={(leagueId) =>
              setSelectedDivisionLeagueId(leagueId)
            }
            showLeaderboard={true}
          />
        )}
      </TabPanel>
      <TabPanel value={value} index={5}>
        {messages !== null && <InboxTable rows={messages} />}
      </TabPanel>
      <TabPanel value={value} index={6}>
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          mb={5}
        >
          <Typography variant="h4" gutterBottom></Typography>
          <Button
            variant="contained"
            startIcon={<Iconify icon="eva:plus-outline" />}
            onClick={() => setOpenAddVersusPackDialog(true)}
          >
            Add Pack
          </Button>
        </Stack>

        <Box sx={{ width: "100%" }}>
          <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
            <Tabs
              value={versusTabValue}
              onChange={handleChangeVersusTabs}
              aria-label="versus tabs"
            >
              <Tab label="Games" {...a11yProps(0)} />
              <Tab label="Contracts" {...a11yProps(1)} />
            </Tabs>
          </Box>
          <TabPanel value={versusTabValue} index={0}>
            <VersusUserGamesTable
              userId={userId}
              isActive={versusTabValue === 0}
            />
          </TabPanel>
          <TabPanel value={versusTabValue} index={1}>
            {versusContracts !== null && (
              <VersusContractsTable rows={versusContracts} />
            )}
          </TabPanel>
        </Box>
      </TabPanel>

      <TabPanel value={value} index={7}>
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          mb={5}
        >
          <Typography variant="h4" gutterBottom></Typography>
          <Button
            variant="contained"
            startIcon={<Iconify icon="eva:plus-outline" />}
            onClick={() => setOpenAddTicketsDialog(true)}
          >
            Add Tickets
          </Button>
        </Stack>
        {ticketTransactions === null ? (
          <Box
            sx={{ display: "flex", justifyContent: "center" }}
            style={{ padding: 20 }}
          >
            <CircularProgress />
          </Box>
        ) : (
          <TicketTransactionsTable transactions={ticketTransactions} />
        )}
      </TabPanel>
      <TabPanel value={value} index={8}>
        {messages !== null && <UserLevelTable rows={userLevelStats} level={userLevel} />}
      </TabPanel>
    </Box>
  );
}
